module.exports = __webpack_public_path__ + "img/PRODUCT_FILTER_AS_SLIDER.68a80fa3.svg";